import { render, staticRenderFns } from "./TiersMoralIcon.vue?vue&type=template&id=2ae2ab68&"
import script from "./TiersMoralIcon.vue?vue&type=script&lang=js&"
export * from "./TiersMoralIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports